import * as React from 'react';
export const IcSimOff = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.71 3.29a.999.999 0 00-1.42 0l-16 16a1 1 0 00.325 1.64 1 1 0 001.095-.22l.53-.54A3 3 0 008 22h8a3 3 0 003-3V6.41l1.71-1.7a.998.998 0 000-1.42zM12 20H8a1 1 0 01-1-1v-.59L8.41 17H12v3zm5-1a1 1 0 01-1 1h-2v-3h3v2zm0-4h-5v-1.59L13.41 12H17v3zM7 12h.76l9.64-9.64A3 3 0 0016 2h-5a2.86 2.86 0 00-1.32.29 3 3 0 00-1.06.84l-3 3.7A3 3 0 005 8.7v6.06l2-2V12z'
      fill='currentColor'
    />
  </svg>
);
